import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import useAPI from '../../hooks/useAPI';
import Loading from '../Loading/Loading';


const EventPage = () => {
  const [active_tab, set_active_tab] = useState('upcoming'); // logic for the tabs
  const {
    data: eventData,
    loading,
    error,
  } = useAPI('/Events/events');

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  // console.log('Event Data:', eventData);
  
  const eventsArray = eventData?.data || [];
  const display_events = eventsArray.filter(
    (e) => e.type === active_tab
  );

  return (
    <main className="min-h-screen bg-slate-50 pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        
        {/* TOP SECTION: Tabs & Header */}
        <div className="flex flex-col items-center mb-20 text-center">
          <span className="text-primary font-bold tracking-[0.2em] uppercase text-xs mb-4">
            event directory
          </span>
          <h1 className="text-5xl md:text-6xl font-black text-dark mb-10 tracking-tight">
            {active_tab === 'upcoming' ? 'upcoming sessions.' : 'the event archive.'}
          </h1>

          {/* TABS NAVIGATION */}
          <div className="inline-flex bg-dark/[0.03] p-1.5 rounded-2xl border border-dark/[0.05]">
            {['upcoming', 'past'].map((tab) => (
              <button 
                key={tab}
                onClick={() => set_active_tab(tab)}
                className={`px-10 py-3.5 rounded-xl text-xs font-bold uppercase tracking-widest transition-all ${
                  active_tab === tab 
                    ? "bg-white text-primary shadow-xl shadow-dark/5" 
                    : "text-dark/40 hover:text-dark/60"
                }`}
              >
                {tab} events
              </button>
            ))}
          </div>
        </div>

        {/* GRID SECTION */}
        <motion.div 
          layout
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-12"
        >
          <AnimatePresence mode="popLayout">
            {display_events?.map((event, index) => (
              <motion.div 
                key={index}
                layout
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.4 }}
                className="group relative"
              >
                {/* Event Card UI remains same as your original design */}
                <div className="relative aspect-[4/5] rounded-[2.5rem] overflow-hidden bg-dark/5 mb-8 shadow-2xl shadow-dark/5">
                  <img 
                    src={event?.image} 
                    alt={event?.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute top-6 left-6 w-20 h-24 bg-white/80 backdrop-blur-md rounded-3xl flex flex-col items-center justify-center border border-white/50 shadow-lg">
                    <span className="text-3xl font-black text-dark leading-none">{event?.event_day}</span>
                    <span className="text-[10px] font-bold text-primary mt-1 tracking-widest uppercase">{event.event_month}</span>
                  </div>
                </div>

                <div className="px-2">
                  <h3 className="text-2xl font-bold text-dark leading-[1.1] mb-4 group-hover:text-primary transition-colors">
                    {event?.title}
                  </h3>
                  <div className="flex items-center text-dark/40 text-sm font-medium">
                    <span className="bg-primary/10 text-primary px-2 py-0.5 rounded text-[10px] font-black uppercase mr-3">
                      {event?.start_time} - {event?.end_time}
                    </span>
                    {event?.location}
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        {/* Empty State */}
        {display_events?.length === 0 && (
          <div className="py-20 text-center">
            <p className="text-dark/30 font-bold uppercase tracking-widest">no {active_tab} events found.</p>
          </div>
        )}
      </div>
    </main>
  );
};

export default EventPage;